var render = function render(){var _vm=this,_c=_vm._self._c;return _c('wechat-applyment-wizard',{key:_vm.wizardKey,attrs:{"mode":"shop","id":_vm.applymentId}})
}
var staticRenderFns = []

export { render, staticRenderFns }